import * as React from 'react';

export default (props:any) => (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10 1.667A8.336 8.336 0 001.667 10c0 4.6 3.733 8.333 8.333 8.333S18.333 14.6 18.333 10 14.6 1.667 10 1.667zm.833 14.166H9.167v-1.666h1.666v1.666zm1.725-6.458l-.75.767c-.6.608-.975 1.108-.975 2.358H9.167v-.417c0-.916.375-1.75.975-2.358l1.033-1.05c.308-.3.492-.717.492-1.175 0-.917-.75-1.667-1.667-1.667s-1.667.75-1.667 1.667H6.667a3.332 3.332 0 116.666 0c0 .733-.3 1.4-.775 1.875z"
            fill='currentColor'
        />
    </svg>
);
